import AOS from 'aos';
import WOW from 'wowjs';
/*----------------------------------------------
1. Preloader
----------------------------------------------*/
(function ($) {
	'use strict';

	$(window).on('load', function() {
		$('.preloader-wapper').addClass('loaded');

		if ($('.preloader-wapper').hasClass('loaded')) {
			$('.preloader-main').delay(1200).queue(function () {
				$(this).remove();
			});
		}
	})

}(jQuery));

/*----------------------------------------------
2. Responsive Menu
----------------------------------------------*/
(function ($) {

	'use strict';

	// Clone the navbar for the responsive menu
	function navResponsive() {
		let navbar = $('.navbar .items');
		let menu = $('#menu .items');

		menu.html('');
		navbar.clone().appendTo(menu);

		$('.menu .icon-arrow-right').removeClass('icon-arrow-right').addClass('icon-arrow-down');
	}

	navResponsive();

	// Re-trigger cloning on window resize
	$(window).on('resize', function () {
		navResponsive();
	});

	// Add a class for dropdowns based on the number of child items
	$('.menu .dropdown-menu').each(function () {
		var children = $(this).children('.dropdown').length;
		$(this).addClass('children-' + children);
	});

	// Add 'prevent' class to nav items with dropdowns
	$('.menu .nav-item.dropdown').each(function () {
		var children = $(this).children('.nav-link');
		children.addClass('prevent');
	});

	// Toggle dropdown menu and rotate icon-arrow-down
	$(document).on('click', '#menu .nav-item .nav-link', function (event) {
		if ($(this).hasClass('prevent')) {
			event.preventDefault();
		}

		var nav_link = $(this);
		var parentNav = nav_link.closest('.nav-item'); // Get the parent nav-item
		var currentDropdown = nav_link.next('.dropdown-menu'); // Get the current dropdown
		var arrowIcon = nav_link.find('.icon-arrow-down'); // Get the arrow icon

		// Close sibling dropdowns and reset their arrow icons
		parentNav.siblings().find('.dropdown-menu.show').slideUp(300).removeClass('show');
		parentNav.siblings().find('.icon-arrow-down').removeClass('rotate-arrow'); // Reset arrow rotation

		// Toggle the current dropdown and rotate the arrow icon
		currentDropdown.slideToggle(300).toggleClass('show');
		arrowIcon.toggleClass('rotate-arrow'); // Add rotation class to arrow icon

		if (nav_link.hasClass('smooth-anchor')) {
			$('#menu').modal('hide');
		}
	});

}(jQuery));

/*----------------------------------------------
3. Navigation
----------------------------------------------*/
(function ($) {

	'use strict';

	var position = $(window).scrollTop();
	var navbar = $('.navbar');
	var toTop = $('#scroll-to-top');

	// Hide navbar initially if scroll position > 0
	$(document).ready(function () {
		if (position > 0) {
			// navbar.hide();
		}
	});

	toTop.hide();

	// Smooth scrolling for internal links
	$('.nav-link').each(function () {
		let href = $(this).attr('href');
		if (href.length > 1 && href.indexOf('#') != -1) {
			$(this).addClass('smooth-anchor');
		}
	});

	// Smooth scroll on click
	$(document).on('click', '.smooth-anchor', function (event) {
		event.preventDefault();
		$('html, body').animate({
			scrollTop: $($.attr(this, 'href')).offset().top
		}, 500);
	});

	// Prevent default action for empty anchor links
	$(document).on('click', 'a[href="#"]', function (event) {
		event.preventDefault();
	});

	// Dropdown hover effect for desktop
	$('.dropdown-menu').each(function () {
		let dropdown = $(this);
		dropdown.hover(function () {
			dropdown.parent().find('.nav-link').first().addClass('active');
		}, function () {
			dropdown.parent().find('.nav-link').first().removeClass('active');
		});
	});

}(jQuery));


/*----------------------------------------------
7. AOS
----------------------------------------------*/
(function ($) {

	'use strict';

	AOS.init();

}(jQuery));

/*----------------------------------------------
8. Wow JS
----------------------------------------------*/
(function ($) {

	'use strict';
	new WOW.WOW({
        live: false
    }).init();

}(jQuery));

/*----------------------------------------------
9. Contact Form
----------------------------------------------*/
(function ($) {

	'use strict';

	var form = $('#contact-form');
	var formMessages = $('.form-message');
	$(form).submit(function (e) {
		e.preventDefault();
		var formData = $(form).serialize();
		$.ajax({
			type: 'POST',
            'accept': 'application/json',
			url: $(form).attr('action'),
			data: formData
		})
		.done(function (response) {
			$(formMessages).removeClass('alert-danger');
			$(formMessages).addClass('alert-success');
			$(formMessages).text(response.message);
			$('#contact-form input, #contact-form textarea').val('');
		})
		.fail(function (data) {
            var message = data.responseJSON.message;
            var errors = data.responseJSON.errors;
            $(formMessages).addClass('alert-danger');
            $(formMessages).removeClass('alert-success');
            if(message){
                $(formMessages).text(message);
            } else {
				$(formMessages).text('Oops! An error occured and your message could not be sent.');
			}
		});
	});

}(jQuery));
